<script>
  import { selectedGroup } from '../store.js'; 
  import { createEventDispatcher} from 'svelte';
  import { Modal, ModalBody, ModalFooter, ModalHeader, CustomInput } from 'sveltestrap';
  import http from '../api/http.js';


  const dispatch = createEventDispatcher();

  let shown = false;

  const createCredential = 'createCredential'
  const editCredential = 'editCredential'
  let manageMode = editCredential;
  let modeText = '';

  let selectedCredentialId = 0;
  let credentialName = '';
  let credentialUsername = '';
  let credentialPassword = '';
  let useCredentialDomain = false;
  let tempDomain = '';
  let credentialDomain = '';

  let errorMessage = '';
  let errorMessageName = '';
  let errorMessageUsername = '';
  let errorMessagePassword = '';
  let errorMessageDomain = '';


  function validateCredentialsName(name){
    if(name.length > 100 || name.length < 1){
      errorMessageName = 'Credential name must be between 1 and 100 characters.';
    }else{
      errorMessageName = '';
    }

    setErrorMessageIfInvalid();
  }

  function validateCredentialsUsername(username){
    if(username.length > 20 || username.length < 1){
      errorMessageUsername = 'Username must be between 1 and 20 characters.';
    }else{
      errorMessageUsername = '';
    }

    setErrorMessageIfInvalid();
  }

  function validateCredentialsPassword(password){
    if(password.length > 127 || password.length < 1){
      errorMessagePassword = 'Password must be between 1 and 127 characters.';
    }else{
      errorMessagePassword = '';
    }

    setErrorMessageIfInvalid();

  }

  function validateCredentialsDomain(domain){
    if((domain.length > 15 || domain.length < 1) && useCredentialDomain){
      errorMessageDomain = 'Domain must be between 1 and 15 characters.';
    }else{
      errorMessageDomain = '';
    }

    setErrorMessageIfInvalid();
  }

  function runValidation(){
    validateCredentialsName(credentialName);
    validateCredentialsUsername(credentialUsername);

    if(manageMode == createCredential){
      validateCredentialsPassword(credentialPassword);
    }

    if(useCredentialDomain){
      validateCredentialsDomain(credentialDomain);
    }

    setErrorMessageIfInvalid();

    if(!errorMessage){
      postCredentials();
    }
  }

  function setErrorMessageIfInvalid(){
    if(!errorMessageName && !errorMessageUsername && !errorMessagePassword && !errorMessageDomain){
      errorMessage = '';
    }else{
      errorMessage = 'Please update above requirements';
    }
  }

  function setUseCredentialDomain(){
    if(useCredentialDomain){
      useCredentialDomain = false;
      credentialDomain = '';
    }else{
      useCredentialDomain = true;
      
      if(manageMode == editCredential && credentialDomain != null){
        credentialDomain = tempDomain;
      }
    }

    validateCredentialsDomain(credentialDomain);
  }

  async function postCredentials(){
    let res = '';

    if(!useCredentialDomain){
      credentialDomain = '';
    }

    if(manageMode == createCredential){
      let credential = {
        name: credentialName,
        username: credentialUsername,
        password: credentialPassword,
        domain: credentialDomain
      }
      res = await http.post(window.apiBaseUrl + `/deploy/dashboard/credentials/create/${$selectedGroup}`, credential);
    }else if(manageMode == editCredential){
      let credential = {
        name: credentialName,
        username: credentialUsername,
        domain: credentialDomain
      }
      res = await http.put(window.apiBaseUrl + `/deploy/dashboard/credentials/edit/${selectedCredentialId}/${$selectedGroup}`, credential);
    }

    if (res.status == 200){
      dispatch('modalClosed');
      toggle();
    }else{
      errorMessage = 'Something went wrong, please try again.';
    }
  }

  function toggle() {
    if(shown){
      shown = false;
      setMode(manageMode);
    }else{
      shown = true;
    }
  }

  function setMode(selectedMode){
    errorMessage = '';
    errorMessageName = '';
    errorMessageUsername = '';
    errorMessagePassword = '';
    errorMessageDomain = '';
    selectedCredentialId = '';
    credentialName = '';
    credentialUsername = '';
    credentialPassword = '';
    credentialDomain = '';
    useCredentialDomain = false;

    if(selectedMode == createCredential){
      manageMode = createCredential;
      modeText = 'Add Credentials';
      credentialName = '';
      credentialUsername = '';
      useCredentialDomain = true;
      credentialDomain = '';
    }else if(selectedMode == editCredential){
      manageMode = editCredential;
      modeText = 'Edit Credentials';
    }
  }

  export async function show(mode, selectedCredential){
    if(mode == createCredential){
      setMode(createCredential);
    }else if(mode == editCredential){
      setMode(editCredential);
      selectedCredential = selectedCredential;
      selectedCredentialId = selectedCredential.id;
      credentialName = selectedCredential.name;
      credentialUsername = selectedCredential.username;
      tempDomain = selectedCredential.domain;
      credentialDomain = tempDomain;

      if(credentialDomain == ""){
        useCredentialDomain = false;
      }else{
        useCredentialDomain = true;
      }
    }
    shown = true;
  }
</script>

<Modal size="lg" isOpen={shown}>
  <ModalHeader>
    Manage Credentials
  </ModalHeader>
  <ModalBody>
    <div class="container">
      <div class=" d-flex">
        <h5 class="mt-2 m-2 modalHeading">{modeText}</h5>
      </div>
      <div>
        <h4 class="input-header mb-3 m-2">Name</h4>
        <input id="name-input" type="text" class="form-control" placeholder="Credentials Name" bind:value={credentialName} on:input={() => validateCredentialsName(credentialName)}>
        <p class="text-danger">{errorMessageName}</p>
        <h4 class="input-header mb-3 m-2">Username</h4>
        <input id="username-input" type="text" class="form-control" placeholder="Username" bind:value={credentialUsername} on:input={() => validateCredentialsUsername(credentialUsername)}>
        <p class="text-danger">{errorMessageUsername}</p>
        {#if manageMode == createCredential}
          <h4 class="input-header mb-3 m-2">Password</h4>
          <input id="password-input" type="text" class="form-control" placeholder="Password" bind:value={credentialPassword} on:input={() => validateCredentialsPassword(credentialPassword)} disabled={manageMode == editCredential}>
          <p class="text-danger">{errorMessagePassword}</p>
        {/if}
        <div class="d-flex">
          <h4 class="input-header mb-3 m-2">Domain</h4>
          <div class="ml-auto">
            <CustomInput type="switch" checked={useCredentialDomain == true} id="setUseCredentialDomain" on:change={() => setUseCredentialDomain()} label="Use Domain"></CustomInput>
          </div>
        </div>
        <input id="domain-input" type="text" class="form-control" placeholder="Domain" bind:value={credentialDomain} on:input={() => validateCredentialsDomain(credentialDomain)} disabled={!useCredentialDomain}>
        <p class="text-danger">{errorMessageDomain}</p>
      </div>
      <p class="text-danger">{errorMessage}</p>
    </div>
  </ModalBody>
  <ModalFooter>
    <button class="btn btn-outline-primary" on:click={() => toggle()} id="cancel-button">Cancel</button>
    <button class="btn btn-primary" on:click={() => runValidation()} id="create-credential-button">{manageMode == createCredential ? "Create" : "Edit"} Credentials</button>
  </ModalFooter>
</Modal>

<style>

  input[type="text"]:disabled{
    background-color: #e9ecef;
  }

</style>